import React from "react";
import { X, ExternalLink } from "lucide-react";
import { ASSET_URL } from "../lib/api";

// Closable full-screen PDF viewer modal.
export default function PdfViewer({ src, title, onClose }) {
  React.useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [onClose]);

  const url = ASSET_URL(src);

  return (
    <div
      className="fixed inset-0 z-[200] flex flex-col bg-black/80"
      style={{ WebkitBackdropFilter: "blur(8px)", backdropFilter: "blur(8px)" }}
      data-testid="pdf-viewer"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-center justify-between gap-4 px-4 md:px-8 py-3 bg-[var(--ink)] text-white">
        <div className="font-mono text-[11px] md:text-sm tracking-[0.14em] uppercase truncate">{title || "PDF"}</div>
        <div className="flex items-center gap-3 shrink-0">
          <a href={url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 font-mono text-[11px] uppercase underline" data-testid="pdf-open-newtab">
            <ExternalLink size={13} /> Neuer Tab
          </a>
          <button onClick={onClose} className="inline-flex items-center gap-1.5 font-mono text-[11px] uppercase border border-white/40 rounded-full px-3 py-1.5 hover:bg-white hover:text-[var(--ink)] transition-colors" data-testid="pdf-close-btn" aria-label="Schließen">
            <X size={14} /> Schließen
          </button>
        </div>
      </div>
      <div className="flex-1 bg-[#333]">
        <iframe title={title || "PDF"} src={`${url}#view=FitH`} className="w-full h-full border-0" data-testid="pdf-iframe" />
      </div>
    </div>
  );
}
